import validate from './validate';
import { prepareAccountNumber } from '../account-generator';


const form = document.querySelector('.payment-tax-form');
const peselLength = 11;
const nipLength = 10;


export const preparePaymentTaxFromForm = (formData) => {
    if (!formData) return false;

    const data = Object.fromEntries(new FormData(formData).entries());

    let streetHouseNo = data.street_house_no;
    streetHouseNo += data.street_staircase_no ? `/${data.street_staircase_no}` : '';
    streetHouseNo.trim();

    const result = {
        'taxDetails': {
            'taxpayerIdType': data.id_type === 'pesel' ? 'P' : 'N',
            'nip': data.nip && data.id_type === 'nip' ? data.nip : '',
            'pesel': data.pesel && data.id_type === 'pesel' ? data.pesel : '',
            'year': data.period_year,
            'periodType': data.period_type,
            'periodNumber': data.period_no,
            'paymentFormSymbol': data.document_type,
            'verificationFName': data.customer_first_name || null,
            'verificationLName': data.customer_last_name || null,
            'verificationStreet': data.street,
            'verificationStreetHouseNo': streetHouseNo,
            'verificationPostalCode': data.postal_code,
            'verificationCity': data.city,
            'companyName': data.company_name || null,
        },
        'creatorSystem': 'MIKRORACHUNEK',
        'creatorUuid': prepareUuid(),
        // 'title': 'Test title',
        'account': data.tax_account,
        'currency': 'PLN',
        'amount': data.tax_amount,
        'returnUrl': 'https://mikrorachunek.pl/platnosci_test?status=awaiting&show=1',
        'receiverName': 'e-file'
    };

    return result;
}

export const prepareUuid = () => {
    const cryptoObj = window.crypto || window.msCrypto;
    const buffer = new Uint16Array(8);
    cryptoObj.getRandomValues(buffer);

    let hex = '';
    for (let i = 0; i < buffer.length; i++) {
        hex += buffer[i].toString(16).padStart(4, '0');
    }

    return `${hex.substr(0, 8)}${hex.substr(8, 4)}${hex.substr(12, 4)}${hex.substr(16, 4)}${hex.substr(20, 12)}`;
}

export const lockFormFields = (form) => {
    form.classList.add('payment-tax-form--loading');
}

export const unlockFormFields = (form) => {
    form.classList.remove('payment-tax-form--loading');
}

export const periodTypeChanged = (target) => {
    const value = target.value;
    const field = form.querySelector('[name="period_no"]');
    if (!field) return false;

    const parentTarget = target.parentElement;
    const parentField = field.parentElement;

    if (value != 'R' && value != 0) {
        parentField.classList.remove('d-none');
        parentTarget.classList.remove('col-md-6');
        parentTarget.classList.add('col-md-4');
    } else {
        field.value = '';
        parentField.classList.add('d-none');
        parentTarget.classList.remove('col-md-4');
        parentTarget.classList.add('col-md-6');
    }
}

export const checkPeriodType = () => {
    const field = form.querySelector('[name="period_type"]');
    if (!field) return false;

    periodTypeChanged(field);
}

export const addCommission = (amount) => {
    const element = form.querySelector('#commission');
    if (!element) return false;

    if (/^[\d\,\.]+$/.test(amount.value) && (parseFloat(amount.value.replace(',', '.')) < parseFloat('4300.00'))) {

        const preparedAmount = parseFloat(amount.value.replace(',', '.'));
        const commission = parseFloat(Math.ceil(preparedAmount / 1000));
        element.innerHTML = commission.toFixed(2);
    } else {
        element.innerHTML = '0,00';
    }
}

export const getType = () => {
    const btn = form.querySelector('button[data-type].active');
    const select = form.querySelector('.id-type select');
    if (!btn || !select) return false;

    const personIdType = select.value;
    const type = btn.getAttribute('data-type');
    const typeId = type === 'person-data' ? (
        !personIdType ?
            1 : (
                personIdType === 'pesel' ?
                    1 : 2
            )
    ) : 2;
    const label = typeId === 1 ? 'PESEL' : 'NIP';

    return { id: typeId, name: type, label };
}

export const prepareAccount = (showError = true) => {
    if (!form) return false;

    const field = form.querySelector('.id-data input');
    const type = getType();

    if (field.value != '' && validate(form, type.label.toLowerCase())) {
        const account = prepareAccountNumber(type.id, field.value);
        if (typeof account === 'undefined' || !account || account.isError) return false;

        setAccountField(account.raw);
    }
}

const setAccountField = (accountNo) => {
    const field = form.querySelector('[name="tax_account"]');
    if (!field) return false;

    field.value = accountNo;
}

export const setEntityIdType = (clear = true) => {
    const idDataGroup = form.querySelector('.id-data');
    if (!idDataGroup) return false;

    const type = getType();
    const label = idDataGroup.querySelector('label');
    const field = idDataGroup.querySelector('input');

    label.innerText = type.id === 2 ? 'NIP *' : 'PESEL *';
    field.name = type.id === 2 ? 'nip' : 'pesel';
    if (clear) field.value = '';

    if (type.id === 2) {
        field.setAttribute('maxlength', nipLength);
        field.setAttribute('placeholder', 'np. 7771112233 (bez myślników)');
    } else {
        field.setAttribute('maxlength', peselLength);
        field.setAttribute('placeholder', 'np. 79010123589');
    }
}

export const clearAccountField = () => {
    const field = form.querySelector('[name="tax_account"]');
    if (!field) return false;

    field.value = '';
}

export const resetEntityTypeBtns = (activeItemKey = -1) => {
    if (!form) return false;

    const btnTypes = form.querySelectorAll('button[data-type]');

    btnTypes.forEach((item, key) => {
        const type = item.getAttribute('data-type');
        item.classList.remove('active');

        if (activeItemKey >= 0 && key === activeItemKey) item.classList.add('active');

        if (typeof type !== 'undefined' && type) {
            const itemFieldsWrap = form.querySelector(`#${type}`);

            if (typeof itemFieldsWrap !== 'undefined' && itemFieldsWrap) {
                const inputs = itemFieldsWrap.querySelectorAll('input');

                if (activeItemKey >= 0 && key === activeItemKey) itemFieldsWrap.classList.remove('d-none');
                else itemFieldsWrap.classList.add('d-none');

                if (inputs.length > 0) inputs.forEach(input => input.value = '');
            }
        }
    })
};
